import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLogIn } from 'react-icons/fi';
import toast from 'react-hot-toast';

const JoinRoomCard = () => {
  const navigate = useNavigate();
  const [roomCode, setRoomCode] = useState('');

  const handleJoinRoom = (e) => {
    e.preventDefault();

    if (!roomCode.trim()) {
      toast.error('Please enter a classroom code');
      return;
    }

    const formattedRoomCode = roomCode.trim().toUpperCase();
    toast.success('Opening classroom');
    navigate(`/room/${formattedRoomCode}`);
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden transform hover:scale-105 transition duration-300">
      <div className="h-2 bg-gradient-to-r from-green-600 to-teal-600"></div>
      <div className="p-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
            Join Classroom
          </h2>
          <FiLogIn className="text-4xl text-green-600" />
        </div>
        
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Enter the classroom code provided by the teacher to join an existing session.
        </p>

        <form onSubmit={handleJoinRoom} className="space-y-4">
          <input
            type="text"
            placeholder="Enter 6-digit classroom code"
            value={roomCode}
            onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
            className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white text-center text-2xl font-mono"
            maxLength="6"
          />

          <button
            type="submit"
            disabled={roomCode.length !== 6}
            className="w-full bg-gradient-to-r from-green-600 to-teal-600 text-white py-3 rounded-lg font-semibold hover:from-green-700 hover:to-teal-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Join Classroom
          </button>
        </form>

        <div className="mt-4 text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Example codes: ABC123, XYZ789
          </p>
        </div>
      </div>
    </div>
  );
};

export default JoinRoomCard;
